import { ReportPayload, ReportType } from "~/report.type";
import { Api } from "../api.service";
import { FileService } from "../file.service";
import i18n from "@/plugins/i18n";
import { ReportAction } from "~/services/report";

export class ReportsService {
  static get baseUrl() {
    return "/pentaho-reports";
  }

  static get types() {
    return {
      pdf: "pdf",
      excel: "xlsx",
      text: "text",
    };
  }
  static get noDataError() {
    return "DataFactoryScriptingSupport: Failed to invoke postProcessResult method.";
  }
  static get parametersError() {
    return "The parameters provided for this report are not valid.";
  }
  static validateResponse(response: any, selectedType: string) {
    const types = { excel: "PK", pdf: "PDF", text: "text" };
    if (selectedType === "text") return true;
    return response
      .substring(0, 7)
      .includes(types[selectedType as keyof typeof ReportType]);
  }

  static openTab(action: ReportAction) {
    if (action != "open") return null;

    const tab = window.open("", "_blank");
    if (!tab) return null;

    tab.document.title = "Идет загрузка...";
    const container = tab.document.createElement("div");
    container.innerHTML = `
          <p>${i18n.t("ui.document_loading")}</p>
        `;
    tab.document.body.append(container);
    return tab;
  }

  static async generateReport(payload: ReportPayload): Promise<string> {
    const { action, path, type, filename, query } = payload;
    let tab = undefined;
    if (action) tab = this.openTab(action);

    const { data } = await Api.get(this.baseUrl, {
      params: {
        path,
        type,
        ...query,
      },
      responseType: payload.type === "text" ? "text" : "blob",
    });

    const str = await new Response(data).text();
    // уточнить у Олеси по поводу перевода ошибок
    if (str == this.noDataError) {
      tab?.close();
      throw Error(i18n.t("reportsInfo.no-data") as string);
    }
    if (str == this.parametersError) {
      tab?.close();
      throw Error("Недостаточно параметров");
    }
    if (!this.validateResponse(str, type)) {
      tab?.close();
      throw Error(i18n.t("reportsInfo.runtime-error") as string);
    }

    const name = `${filename}.${this.types[type as keyof typeof ReportType]}`;
    if (action === "download") FileService.downloadFile(data, name);
    else if (action === "open") FileService.openPdfInNewTab(data, tab);

    return data as string;
  }
}
